// extracted by mini-css-extract-plugin
export default {"box":"box--diYUX","boxItems":"boxItems--WeY9B"};